import utils from './utils'
import user from './user'
import auth from './auth'
import chat from './chat'
import ai from './ai'
import doctor from './doctor'
import xiaofu from './xiaofu'
import pill from './pill'


export default {
  doctor,
  user,
  utils,
  auth,
  chat,
  ai,
  xiaofu,
  pill
}
